<script>
export default {
    inheritAttrs: false,
}
</script>

<script setup>
import { twMerge } from 'tailwind-merge';
import { computed, useAttrs } from 'vue';

const attrs = useAttrs();
const classes = computed(() => {
    return attrs.class;
});

const restAttrs = computed(() => {
    const { class: _, ...rest } = attrs;
    return rest;
});
</script>

<template>
    <div role="status" :class="twMerge('max-w-sm animate-pulse', classes)" v-bind="restAttrs">
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
    </div>
</template>
